export class ChangePasswordModel {
  oldPassword: string;
  newPassword: string;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/account/change-password.model.ts